<template>
  <div class="footer">
    <div class="footer__fullscreen-link" @click="toogleFullScreen()">
      <icon name="footer-icon-1" />
      <div class="tooltip left">מסך מלא</div>
    </div>

    <ul class="footer__controls">
      <!-- <li class="footer__controls-item">
        <a href="" class="footer__controls-link">
          <icon name="footer-icon-2" />
          <div class="tooltip top">הגדרות</div>
        </a>
      </li> -->
      <li class="footer__controls-item">
        <a
          class="footer__controls-link"
          tabindex="0"
          @click="show = !show"
          @keyup.enter="show = !show"
        >
          <icon name="footer-icon-3" />
          <div class="tooltip left">מידע</div>
          <div class="popup-info" :class="{ active: show }">
            <div class="popup-info__wrapp">
              <ul>
                <li class="period__submenu-list-item">
                  <a
                    href="https://www.smart-campus.co.il/terms-use/"
                    target="_blank"
                    tabindex="0"
                    >תקנון ותנאי שימוש</a
                  >
                </li>
                <li class="period__submenu-list-item">
                  <a
                    href="https://www.smart-campus.co.il/privacy/"
                    target="_blank"
                    tabindex="0"
                    >מדיניות פרטיות</a
                  >
                </li>
                <li class="period__submenu-list-item">
                  <a
                    href="https://www.smart-campus.co.il/accessibility/"
                    target="_blank"
                    tabindex="0"
                    >הצהרת נגישות</a
                  >
                </li>
                <li class="period__submenu-list-item">
                  <a
                    href="https://www.smart-campus.co.il/"
                    target="_blank"
                    tabindex="0"
                    >אתר סמארט קמפוס</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </a>
      </li>
      <!-- <li class="footer__controls-item">
        <a href="" class="footer__controls-link">
          <icon name="footer-icon-4" />
          <div class="tooltip top">קבצים (בקרוב)</div>
        </a>
      </li> -->
    </ul>
    <ul class="footer__submenu">
      <li>
        <a
          class="open-accessibility open-accessibility-collapsed"
          @click="openAccessibility"
        >
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.1001 5.29999C12.1001 6.2941 11.2942 7.09998 10.3001 7.09998C9.306 7.09998 8.50012 6.2941 8.50012 5.29999C8.50012 4.30588 9.306 3.5 10.3001 3.5C11.2942 3.5 12.1001 4.30588 12.1001 5.29999Z"
            ></path>
            <path
              d="M11.1369 8.18341C11.072 7.77431 10.6878 7.49526 10.2787 7.56014C9.86961 7.62502 9.59056 8.00926 9.65544 8.41836L11.1369 8.18341ZM20.1781 18.6285C20.58 18.528 20.8243 18.1208 20.7239 17.719C20.6234 17.3171 20.2162 17.0728 19.8143 17.1732L20.1781 18.6285ZM11.4248 14.7871L10.6841 14.9046L10.8056 15.671L11.5674 15.5235L11.4248 14.7871ZM17.0335 13.7009L17.7611 13.5189L17.5887 12.8294L16.8909 12.9645L17.0335 13.7009ZM18.1963 18.3508L17.4687 18.5328L17.6506 19.2603L18.3782 19.0785L18.1963 18.3508ZM9.65544 8.41836L10.6841 14.9046L12.1656 14.6697L11.1369 8.18341L9.65544 8.41836ZM11.5674 15.5235L17.1761 14.4372L16.8909 12.9645L11.2822 14.0508L11.5674 15.5235ZM16.3059 13.8828L17.4687 18.5328L18.9239 18.1689L17.7611 13.5189L16.3059 13.8828ZM18.3782 19.0785L20.1781 18.6285L19.8143 17.1732L18.0144 17.6232L18.3782 19.0785Z"
            ></path>
            <path
              d="M14.6 11.4492C15.0142 11.4492 15.35 11.1134 15.35 10.6992C15.35 10.285 15.0142 9.94922 14.6 9.94922V11.4492ZM11 11.4492H14.6V9.94922H11V11.4492Z"
            ></path>
            <path
              d="M15.6883 15.6086C15.9044 16.6546 15.8054 17.7411 15.4039 18.7307C15.0024 19.7204 14.3164 20.5688 13.4328 21.1686C12.5491 21.7685 11.5074 22.0928 10.4394 22.1006C9.37144 22.1084 8.32512 21.7993 7.43279 21.2125C6.54046 20.6256 5.84219 19.7873 5.42628 18.8036C5.01037 17.8199 4.8955 16.735 5.0962 15.686C5.29691 14.637 5.80416 13.6711 6.55382 12.9104C7.30349 12.1497 8.26189 11.6284 9.30783 11.4124L9.64301 13.0354C8.91807 13.1851 8.2538 13.5464 7.73421 14.0737C7.21462 14.6009 6.86304 15.2704 6.72393 15.9974C6.58483 16.7245 6.66444 17.4764 6.95271 18.1583C7.24097 18.8401 7.72494 19.4211 8.34342 19.8278C8.96189 20.2346 9.68709 20.4488 10.4273 20.4434C11.1675 20.438 11.8895 20.2132 12.502 19.7974C13.1145 19.3817 13.5899 18.7937 13.8682 18.1077C14.1464 17.4218 14.2151 16.6687 14.0653 15.9438L15.6883 15.6086Z"
            ></path>
          </svg>
          <span>נגישות</span>
        </a>
      </li>
      <li>
        <a onclick="$crisp.push(['do', 'chat:toggle'])">
          <icon width="25" height="25" name="footer-icon-6" />
          <span>תמיכה טכנית</span>
        </a>
      </li>
    </ul>

    <a href="" class="footer__logo">
      <img src="/images/sm-logo.svg" alt="" />
    </a>

    <ul class="footer__data">
      <li class="footer__data-item">
        {{ date }}
      </li>
      <li class="footer__data-item">
        {{ time }}
      </li>
    </ul>
  </div>
</template>
<style>
.popup-info {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 8px 20px rgb(56 69 93 / 10%), 0 4px 9px rgb(56 69 93 / 8%),
    0 2px 5px rgb(56 69 93 / 6%), 0 1px 3px rgb(56 69 93 / 5%),
    0 0.598509px 1.5px rgb(56 69 93 / 4%), 0 0.249053px 1px rgb(56 69 93 / 3%);
  opacity: 0;
  padding: 8px;
  pointer-events: none;
  position: absolute;
  transition: 0.3s;
  min-width: 170px;
  width: 100%;
  bottom: 2px;
  z-index: 99999;
  right: 26px;
}
.popup-info.active {
  opacity: 1;
  pointer-events: all;
}
.popup-info .period__submenu-list-item a {
  color: #38455d;
}
.popup-info .period__submenu-list-item:hover a {
  color: #409fff;
  outline: none;
  text-decoration: none;
}
@media (max-width: 767px) {
  .popup-info {
    right: auto;
    left: 26px;
  }
}
</style>
<script>
export default {
  name: 'TheFooter',
  data() {
    return {
      date: '',
      time: '',
      // moment: moment,
      show: false
    };
  },
  computed: {},
  created() {
    setInterval(this.getNow, 2000);
  },
  methods: {
    toogleFullScreen() {
      const elem = document.body;
      const root = document.getElementsByTagName('html')[0];
      if (
        (document.fullScreenElement !== undefined &&
          document.fullScreenElement === null) ||
        (document.msFullscreenElement !== undefined &&
          document.msFullscreenElement === null) ||
        (document.mozFullScreen !== undefined && !document.mozFullScreen) ||
        (document.webkitIsFullScreen !== undefined &&
          !document.webkitIsFullScreen)
      ) {
        if (elem.requestFullScreen) {
          elem.requestFullScreen();
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullScreen) {
          elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
        root.classList.add('fullscreen');
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        root.classList.remove('fullscreen');
      }
    },
    getNow() {
      const today = new Date();
      let month = today.getMonth() + 1;
      let day = today.getDate();
      let hour = today.getHours();
      let minute = today.getMinutes();
      if (day < 10) {
        day = '0' + day;
      }

      if (month < 10) {
        month = '0' + month;
      }
      if (hour < 10) {
        hour = '0' + hour;
      }
      if (minute < 10) {
        minute = '0' + minute;
      }
      const date = day + '.' + month + '.' + today.getFullYear();

      const time = hour + ':' + minute;

      this.date = date;
      this.time = time;
    },
    openAccessibility() {
      const element = document.querySelector(
        '.open-accessibility-expand-button'
      );
      element.click();
      console.clear();
    }
  }
};
</script>
